var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "NightButton",

    getDefaultProps () {
        return {"width":"48px","height":"48px","viewBox":"0 0 48 48","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Night_button</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Night_button" fill="#034C8C">
      <path d="M0,24 C0,10.745166 10.7422516,0 24,0 C37.254834,0 48,10.7422516 48,24 C48,37.254834 37.2577484,48 24,48 C10.745166,48 0,37.2577484 0,24 Z M30.5,33.051415 L30.5,33.0479879 C27.3375007,31.2607522 25.2073733,27.8773419 25.2073733,24.0012852 C25.2073733,20.1226581 27.3375007,16.7392478 30.5,14.9520121 C28.9273534,14.0618213 27.1525341,13.5965917 25.3450229,13.6000188 C19.5783654,13.6000188 14.9,18.2548854 14.9,23.9987148 C14.9,29.7451146 19.5783654,34.3999812 25.3450229,34.3999812 C27.1525341,34.4034083 28.9273534,33.9381787 30.5,33.051415 Z" id="Combined-Shape"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/images/Night_Button.svg